import React from "react";
import PropTypes from "prop-types";
import "../components/ListBox.css";

export default function Checkboxes({
  label,
  className,
  items,
  onChange,
  checkedList,
  setCustomField
}) {
  return (
    items && (
      <div className={className}>
        <span className="checkbox-label">{label}</span>
        <ul className="checkbox-list">
          {items.map(item => {
            return (
              <li className="checkbox" key={item}>
                <input
                  className="li-item"
                  type="checkbox"
                  id={item}
                  defaultChecked={
                    checkedList ? checkedList.find(c => c === item) : ""
                  }
                  onChange={onChange}
                />
                <label>{item}</label>
              </li>
            );
          })}
          {checkedList.map(checkedItem => {
            return (
              !items.find(c => c === checkedItem) &&
              checkedItem !== "custom" && (
                <li className="checkbox" key={checkedItem}>
                  <input
                    className="li-item"
                    type="checkbox"
                    id={checkedItem}
                    defaultChecked={true}
                    onChange={onChange}
                  />
                  <label>{checkedItem}</label>
                </li>
              )
            );
          })}
          {setCustomField && (
            <li className="checkbox" key="custom">
              <input
                className="li-item"
                type="checkbox"
                id="custom"
                onChange={onChange}
              />
              <label>annat:</label>
              <input
                className="custom-field"
                type="text"
                maxLength="50"
                onChange={e => setCustomField(e.target.value)}
              />
            </li>
          )}
        </ul>
      </div>
    )
  );
}

Checkboxes.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  checkedList: PropTypes.array.isRequired,
  setCustomField: PropTypes.func
};

/*
        {costItems && (
          <ul type="radiogroup">
            {costItems.map(cost => (
              <li className="checkbox" key={cost}>
                <input
                  type="radio"
                  name="foodcost"
                  value={cost}
                  id={cost}
                  checked={checkedCost === cost}
                  onChange={onChange}
                />
                <span className="list-name"> {cost} </span>
              </li>
            ))}
          </ul>
        )}
*/
